import React, { useRef, useEffect } from "react";
import TextField from "@mui/material/TextField";
// import assets from "../../../assets";

export default function MuiTextField({
  inputProps = {},
  onChange,
  size = "small",
  value,
  min = 0,
  max = 100,
  ...rest
}) {
  const inputRef = useRef(null);

  useEffect(() => {
    const handleWheel = (event) => {
      // Check if input type is number
      const inputType = rest?.type;
      if (inputType === "number") {
        event.preventDefault();
      }
    };

    const inputElement = inputRef.current.querySelector('input[type="number"]');
    if (inputElement) {
      inputElement.addEventListener("wheel", handleWheel);
    }

    // Cleanup function to remove the event listener
    return () => {
      if (inputElement) {
        inputElement.removeEventListener("wheel", handleWheel);
      }
    };
  }, [rest?.type]);

  const handleKeyDown = (event) => {
    // Check if input type is number
    const inputType = rest?.type;
    if (
      inputType === "number" &&
      ["ArrowUp", "ArrowDown"].includes(event.key)
    ) {
      event.preventDefault();
    }
  };

  return (
    <TextField
      value={value}
      onChange={onChange}
      size={size}
      min={min}
      max={max}
      sx={{
        "& .MuiInputBase-input.Mui-disabled": {
          WebkitTextFillColor: "#ffffff",
        },
        "& input[type=number]": {
          MozAppearance: "textfield",
        },
        "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
          {
            WebkitAppearance: "none",
            margin: 0,
          },
        ...rest?.fieldStyling,
      }}
      inputProps={{
        ...inputProps,
        style: {
          ...{
            color: "black",
            padding: 10,
            // background: assets.colors.fieldBG,
          },
          ...inputProps?.style,
        },
      }}
      {...rest}
      ref={inputRef}
      onKeyDown={handleKeyDown}
    />
  );
}
